import get from 'lodash/get';
import isObject from 'lodash/isObject';
import { isCustomerApp, isPactApp, isWeb } from '../../redux/reducers/app/appReducer';
import { sendNewRelicCustomEvent } from '../logging/logging-utils';
import queryStrings from '../../constants/queryStringConstants';

const onAuth0ConfigError = (state) => {
  const sessionId = get(state, 'bff.sessionId');
  const timestamp = Date.now();
  const { pathname } = window.location;
  const { userAgent } = window.navigator;

  sendNewRelicCustomEvent('auth0ConfigError', {
    timestamp,
    path: pathname,
    userAgent,
    sessionId,
    errorDescription: 'Auth0 config missing in state using auth0 config from window.env',
  });
};

export function getOrderClaimPasswordLessAuth0Config(state) {
  const config = window.env.AUTH0_CONFIG;

  return {
    domain: config.domain,
    client_id: config.checkoutClientId,
    redirect_uri: config.callbackClaimOrderUrl,
    cancelUrl: config.cancelClaimOrderUrl,
    audience: config.audience,
    scopes: config.scopes,
    prompt: config.prompt,
    initialScreen: isCustomerApp(state) ?
      config.passswordLessClaimOrderCustomerAppInitialScreen :
      config.passwordLessClaimOrderInitialScreen,
  };
}

export function getRegisterAccountAuth0Config(state) {
  const config = window.env.AUTH0_CONFIG;

  return {
    domain: config.domain,
    client_id: config.checkoutClientId,
    redirect_uri: `${config.callbackCreateAccountUrl}?${queryStrings.FULL_SCREEN_SIGNUP_FLOW}`,
    cancelUrl: `${config.cancelCreateAccountUrl}?${queryStrings.CREATE_ACCOUNT_CANCELLED}`,
    audience: config.audience,
    scopes: config.scopes,
    prompt: isCustomerApp(state) ? config.prompt : null,
    email: state?.user?.email,
    initialScreen: isCustomerApp(state)
      ? config.createAccountCustomerAppInitialScreen
      : config.createAccountInitialScreen,
    newSignUpFlow: true,
  };
}

export default function getAuth0Config(state) {
  const stateConfig = state.config?.auth0ClientConfiguration;
  if (isObject(stateConfig)) {
    return stateConfig;
  }

  return (() => {
    onAuth0ConfigError(state);
    const configFallback = window.env.AUTH0_CONFIG;
    return {
      domain: configFallback.domain,
      client_id: isPactApp(state) ? configFallback.pactClientId : configFallback.checkoutClientId,
      redirect_uri: configFallback.callbackAuthenticatedUrl,
      guest_checkout_url: configFallback.callbackGuestUrl,
      audience: configFallback.audience,
      scopes: configFallback.scopes,
      prompt: configFallback.prompt,
      initialScreen: isPactApp(state) ? configFallback.pactInitialScreen : configFallback.checkoutInitialScreen,
      auth0_password_reset: true,
      passwordless_checkout: isWeb(state),
    };
  })();
}
